import { SCIENCE_LINKS, INVESTOR_LINKS } from "../../content/siteContent";

export const audienceSites = {
  scientist: {
    base: "/scientists",
    label: "Scientists",
    fullLabel: "Scientists & biotech teams",
    cta: SCIENCE_LINKS.contact.label,
    navigation: [
      SCIENCE_LINKS.solutions,
      { ...SCIENCE_LINKS.workingTogether, also: ["/scientists/engagements", "/scientists/evaluation", "/pricing", "/benefits"] },
      SCIENCE_LINKS.openProblems,
      SCIENCE_LINKS.fieldNotes,
    ],
    pageTitles: { solutions: SCIENCE_LINKS.solutions.label, engagements: SCIENCE_LINKS.engagements.label, evaluation: SCIENCE_LINKS.evaluation.label },
    pages: { overview: SCIENCE_LINKS.overview.label, "working-together": SCIENCE_LINKS.workingTogether.label, "open-problems": SCIENCE_LINKS.openProblems.label, "field-notes": SCIENCE_LINKS.fieldNotes.label },
  },
  investor: {
    base: "/investors",
    label: "Investors",
    fullLabel: "Investors",
    cta: "Get in touch",
    navigation: [
      INVESTOR_LINKS.vision,
      INVESTOR_LINKS.development,
      INVESTOR_LINKS.work,
      INVESTOR_LINKS.research,
    ],
    pages: { overview: "Our vision" },
  },
  treatment: {
    base: "/patients",
    label: "Patients & families",
    fullLabel: "Patients, families & advocates",
    cta: "Talk with us",
    navigation: [
      { to: "/patients", label: "Our purpose" },
      { to: "/patients/research", label: "Research process" },
      { to: "/patients/questions", label: "Your questions" },
    ],
    pages: { overview: "Our purpose", research: "Research process", questions: "Your questions" },
  },
};

export const legacyHomeAnchors = {
  "#platform": "/scientists#platform",
  "#ai-infrastructure": "/scientists#ai-infrastructure",
  "#open-problems": "/scientists/open-problems#open-problems",
  "#field-notes": "/scientists/field-notes#field-notes",
};

export function audienceFromPath(pathname) {
  return Object.keys(audienceSites).find((id) =>
    pathname === audienceSites[id].base || pathname.startsWith(`${audienceSites[id].base}/`)
  ) || null;
}

export function audienceFromLocation({ pathname, search = "", hash = "" }) {
  const scoped = audienceFromPath(pathname);
  if (scoped) return scoped;
  if (pathname === "/" && legacyHomeAnchors[hash]) return "scientist";
  const params = new URLSearchParams(search);
  const requested = params.get("audience");
  if (Object.prototype.hasOwnProperty.call(audienceSites, requested)) return requested;
  if (pathname === "/contact" && !requested) {
    if (params.get("source") === "investor-story") return "investor";
    if (params.get("source") === "treatment-story") return "treatment";
  }
  return ["/solutions", "/pricing", "/benefits", "/contact"].includes(pathname) ? "scientist" : null;
}

const sciencePaths = {
  "/": "/scientists",
  "/solutions": "/scientists/solutions",
  "/contact": "/scientists/contact",
  "/pricing": "/scientists/engagements",
  "/benefits": "/scientists/evaluation",
};

export function scientificLinkTarget(to, pathname) {
  if (audienceFromPath(pathname) !== "scientist") return to;
  if (typeof to === "string") {
    const match = to.match(/^(\/[^?#]*)(.*)$/);
    if (!match) return to;
    if (match[1] === "/" && legacyHomeAnchors[match[2]]) return legacyHomeAnchors[match[2]];
    return sciencePaths[match[1]] ? `${sciencePaths[match[1]]}${match[2]}` : to;
  }
  return to?.pathname && sciencePaths[to.pathname] ? { ...to, pathname: sciencePaths[to.pathname] } : to;
}
